'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment', 'AVRO.Common.Scenario'];
module.exports = angular.module('AVRO.Reoptimization', dependencies).factory('ReoptimizationService', require('./services/ReoptimizationService')).factory('ReoptimizationSaveService', require('./services/ReoptimizationSaveService')).factory('ReoptPreviewDataUtilsService', require('./services/ReoptPreviewDataUtilsService'));